import { render, staticRenderFns } from "./AIConsultationDrawer.vue?vue&type=template&id=7d648770&scoped=true&lang=pug"
import script from "./AIConsultationDrawer.vue?vue&type=script&lang=js"
export * from "./AIConsultationDrawer.vue?vue&type=script&lang=js"
import style0 from "./AIConsultationDrawer.vue?vue&type=style&index=0&id=7d648770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d648770",
  null
  
)

export default component.exports